import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import "./cmsPage.css"
import { useHistory } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";

const Page_CMS = () => {
    const [page, setPage] = useState();
    const { slug } = useParams();
    const history = useHistory()
    const [open, setOpen] = useState(true);
    console.log("slug: ", slug);

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchPage()
    }, [slug])

    useEffect(() => {
        if (page)
            setOpen(false);
    }, [page])

    const fetchPage = async () => {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/v1/cms/get-page-by-slug?slug=${slug}`);
        if (!response.data) {
            history.push('/404')
        }
        else {
            setPage(response.data);
        }

    }

    return (
        <div className="cms-page">
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}>
                <SyncLoader color={"#ff7e06"} loading={true} css={override} size={11} />
            </Backdrop>
            <div className="container py-5">
                <h1 className="title">{page && page.title}</h1>
                <h5 className="subtitle mb-5">{page && page.subTitle}</h5>
                <div dangerouslySetInnerHTML={{ __html: page && page.pageContent }}></div>
            </div>
        </div>
    );
}

export default Page_CMS;